import { cn } from '@/lib/utils'
import { memo } from 'react'

interface Props {
  categoryId: string
  categoryName: string
}

// Bảng màu ánh xạ `categoryId` -> Màu sắc
const CATEGORY_STYLES: Record<string, { color: string; textColor: string }> = {
  '83c2771a-707f-4c78-aeff-2bbca0b13988': {
    color: 'bg-tagRed',
    textColor: 'text-white', // Tin Tức
  },
  '7c18eec0-24dd-41cc-b416-4e3fce5c7b44': {
    color: 'bg-tagGreen',
    textColor: 'text-white', // Giải Trí
  },
  'dab990dc-e8ff-43aa-b967-5590c00e515e': {
    color: 'bg-tagGreen',
    textColor: 'text-white', // Sức Khỏe
  },
  'e72e7c41-aac7-4134-9188-9e222a7cf0d2': {
    color: 'bg-tagPink',
    textColor: 'text-white', // Du Lịch
  },
  '89ff9b0a-813e-4448-939f-bfeeac85c6b6': {
    color: 'bg-tagTeal',
    textColor: 'text-white', // Đời Sống
  },
  'c635a98e-b52c-459e-a60b-4ba96ed55025': {
    color: 'bg-tagOrange',
    textColor: 'text-white', // Văn hoá
  },
  '3edd81af-d5bb-4069-ae98-e1f0731104f8': {
    color: 'bg-tagBlue',
    textColor: 'text-white', // Ẩm Thực
  },
  '9315d4a8-af6a-4b50-a17d-a6a93f2f4217': {
    color: 'bg-tagTeal',
    textColor: 'text-white', // Di Trú
  },
  'f7d4ec78-9a8b-4673-9d3a-248bcc18a973': {
    color: 'bg-tagBrown',
    textColor: 'text-white', // Bạn Đọc
  },
  '1f9d3e9b-de30-47b8-9c8c-ad7a81a87dcd': {
    color: 'bg-tagOrange',
    textColor: 'text-white', // Buôn Chuyện
  },
}

const DEFAULT_STYLE = { color: 'bg-primary', textColor: 'text-white' }

const getCategoryStyles = (categoryId: string) => CATEGORY_STYLES[categoryId] || DEFAULT_STYLE

const LabelCard: React.FC<Props> = ({ categoryId, categoryName }) => {
  const { color, textColor } = getCategoryStyles(categoryId)

  return (
    <div
      className={cn(
        'absolute top-2 left-2 md:top-4 md:left-4 text-sm font-medium px-2 md:px-4 xl:px-6 py-1',
        color,
        textColor
      )}
    >
      {categoryName || 'Không phân loại'}
    </div>
  )
}

export default memo(LabelCard)
